import * as React from "react";
import { Button, Popconfirm } from "antd";
import { TLegalViewPresentationModel } from "../../presenter/model/LegalViewPresentationModel";
import { IOrganisation } from "../../../organisations/model/Organisation";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import {
  DeleteOutlined,
  EditOutlined,
  EyeFilled,
  LockFilled
} from "@ant-design/icons";
import { LegalViewStatus } from "../../common/Constants";
import { IUser } from "../../../user/model/User";

const LegalViewSidebar = ({
  translate,
  legalView,
  onEditClick,
  publishLegalView,
  archiveLegalView,
  onUndoClick,
  user,
  deleteLegalView
}: {
  translate;
  legalView: TLegalViewPresentationModel;
  legalViewTypes: IDocumentType[];
  organisations: IOrganisation[];
  publishLegalView: any;
  archiveLegalView: any;
  deleteLegalView: any;
  onEditClick: any;
  onUndoClick?: any;
  user?: IUser;
}) => {
  return (
    <div style={{ marginTop: 24, marginLeft: 24 }}>
      <Button
        value=""
        shape={"round"}
        type="link"
        onClick={() => onEditClick(legalView.id)}
      >
        <EditOutlined style={{ marginRight: 5 }} />{" "}
        {translate("editors.legal_views.edit")}
      </Button>
      <br />
      {legalView.status !== LegalViewStatus.ARCHIVED && (
        <Button
          shape={"round"}
          type={"link"}
          onClick={() => archiveLegalView(legalView.id)}
        >
          <LockFilled style={{ marginRight: 5 }} />{" "}
          {translate("editors.case_law_documents.archive")}
        </Button>
      )}
      <br />
      {legalView.status === LegalViewStatus.VERIFIED && (
        <Button
          shape={"round"}
          type={"link"}
          onClick={() => publishLegalView(legalView.id)}
        >
          <EyeFilled style={{ marginRight: 5 }} />{" "}
          {translate("editors.case_law_documents.publish")}
        </Button>
      )}
      {legalView.status === LegalViewStatus.PUBLISHED && (
        <Button
          shape={"round"}
          type={"link"}
          onClick={() => onUndoClick(legalView.id)}
        >
          <EyeFilled style={{ marginRight: 5 }} />{" "}
          {translate("editors.case_law_documents.revert_status")}
        </Button>
      )}
      <br />
      {(user?.isAdmin() || user?.isOperator()) &&
        legalView.status !== LegalViewStatus.ARCHIVED &&
        legalView.status !== LegalViewStatus.INVALIDATED && (
          <Popconfirm
            title={translate("editors.case_law_documents.delete_message")}
            onConfirm={() => deleteLegalView()}
            okText={translate("editors.case_law_documents.confirm")}
            cancelText={translate("editors.case_law_documents.cancel")}
          >
            <Button value="" type="link" shape={"round"}>
              <DeleteOutlined style={{ marginRight: 5 }} />{" "}
              {translate("editors.case_law_documents.delete")}
            </Button>
          </Popconfirm>
        )}
    </div>
  );
};
export default LegalViewSidebar;
